import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, emailVerified } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Google users are always verified; email/password users need verification
  const isGoogleUser = user.providerData.some(p => p.providerId === 'google.com');
  if (!isGoogleUser && !emailVerified) {
    return <Navigate to="/login?verify=true" replace />;
  }

  return <>{children}</>;
}
